import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

//const APP_ROUTES: Routes = [
export const routes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('./virtual-agent/virtual-agent.component')
                .then(m => m.VirtualAgentComponent),
    },
    {
        path: 'status',
        loadComponent: () =>
            import('./status/status.component')
                .then(m => m.StatusComponent),
    },
    {
        path: 'support',
        loadComponent: () =>
            import('./customer-service-form/customer-service-form.component')
                .then(m => m.CustomerServiceFormComponent),
    },
    {
        path: '**',
        loadComponent: () =>
            import('./page-not-found/page-not-found.component')
                .then(m => m.PageNotFoundComponent),
    },
];


@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            initialNavigation: 'enabledBlocking',
        }),
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }
